import React, { useState, useMemo, useEffect } from 'react';
import styled from 'styled-components';
import { grayLightM } from 'web-ui-kit/colors';
import UnsegmentedControlWithImageOnly from 'web-ui-kit/SelectionControls/UnsegmentedControlWithImageOnly';
import ProductImage from 'web-ui-kit/ProductDetails/components/ProductImage';

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var _templateObject, _templateObject2, _templateObject3;
/**
 * A 1x1 aspect ratio image carousel.
 *
 * The number of images and currently visible image is
 * indicated by a grid of image thumbnails.
 *
 * The visible image is updated by clicking on the desired image thumbnail.
 */


function ThumbnailProductImageCarousel(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$dislikeButtonCon = _ref.dislikeButtonConfig,
      dislikeButtonConfig = _ref$dislikeButtonCon === void 0 ? 'hover' : _ref$dislikeButtonCon,
      _ref$dispatch = _ref.dispatch,
      dispatch = _ref$dispatch === void 0 ? function () {} : _ref$dispatch,
      _ref$likeDislikeEnabl = _ref.likeDislikeEnabled,
      likeDislikeEnabled = _ref$likeDislikeEnabl === void 0 ? true : _ref$likeDislikeEnabl,
      _ref$mqTwoColumnUp = _ref.mqTwoColumnUp,
      mqTwoColumnUp = _ref$mqTwoColumnUp === void 0 ? '' : _ref$mqTwoColumnUp,
      _ref$parentProductId = _ref.parentProductId,
      parentProductId = _ref$parentProductId === void 0 ? undefined : _ref$parentProductId,
      _ref$product = _ref.product,
      product = _ref$product === void 0 ? {} : _ref$product;
  var _product$id = product.id,
      id = _product$id === void 0 ? '' : _product$id,
      _product$images = product.images,
      images = _product$images === void 0 ? [''] : _product$images;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      currentImageIndex = _useState2[0],
      setCurrentImageIndex = _useState2[1];

  var currentImage = images[currentImageIndex];
  var likeDislikeConfig = useMemo(function () {
    return {
      enabled: likeDislikeEnabled
    };
  }, [likeDislikeEnabled]);
  useEffect(function () {
    return setCurrentImageIndex(0);
  }, [id]);

  var handleImageClicked = function handleImageClicked(index) {
    return function () {
      setCurrentImageIndex(index);
    };
  };

  var Container = styles.Container,
      HeroImage = styles.HeroImage,
      ThumbnailsGrid = styles.ThumbnailsGrid;
  return (
    /*#__PURE__*/
    React.createElement(Container, {
      className: className,
      "data-testid": "thumbnail-carousel"
    },
    /*#__PURE__*/
    React.createElement(HeroImage, {
      dislikeButtonConfig: dislikeButtonConfig,
      dispatch: dispatch,
      image: currentImage,
      likeDislikeConfig: likeDislikeConfig,
      mqTwoColumnUp: mqTwoColumnUp,
      parentProductId: parentProductId,
      product: product
    }),
    /*#__PURE__*/
    React.createElement(ThumbnailsGrid, null, images.map(function (image, index) {
      var name = "thumbnail ".concat(index + 1);
      var status = index === currentImageIndex ? 'selected' : 'unselected';
      return (
        /*#__PURE__*/
        React.createElement(UnsegmentedControlWithImageOnly, {
          key: "".concat(image, "-").concat(index),
          aspectRatio: 1,
          dispatch: handleImageClicked(index),
          imgixProps: {
            alt: name,
            bucketName: 'modsy',
            height: 128,
            src: image,
            width: 128
          },
          name: name,
          status: status
        })
      );
    })))
  );
}

var styles = {
  Container: styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    position: sticky;\n    top: 0;\n  "]))),
  HeroImage: styled(ProductImage)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    border: 1px solid ", ";\n  "])), grayLightM),
  ThumbnailsGrid: styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    display: grid;\n    grid-template-columns: repeat(5, 1fr);\n    grid-gap: 0.5rem;\n\n    margin-top: 0.75rem;\n  "])))
};
export default ThumbnailProductImageCarousel;